export const UPDATE_OUTLET_CODE = 'UPDATE_OUTLET_CODE'
export const UPDATE_OUTLET_CAMERA_DETAILS = 'UPDATE_OUTLET_CAMERA_DETAILS'